"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _CobaltIcon = _interopRequireDefault(require("../../components/CobaltIcon"));

var AlertTheme = function AlertTheme(colors) {
  return {
    defaultProps: {
      elevation: 0,
      iconMapping: {
        success: /*#__PURE__*/_react["default"].createElement(_CobaltIcon["default"], {
          name: "check-fill"
        }),
        warning: /*#__PURE__*/_react["default"].createElement(_CobaltIcon["default"], {
          name: "alert-fill"
        }),
        error: /*#__PURE__*/_react["default"].createElement(_CobaltIcon["default"], {
          name: "x-fill"
        })
      },
      closeText: 'Fermer'
    },
    styleOverrides: {
      root: {
        position: 'relative',
        padding: '20px 24px',
        color: colors.lynch,
        backgroundColor: colors.white,
        borderRadius: '8px'
      },
      icon: {
        top: '20px',
        left: '23px',
        position: 'absolute',
        height: '16px',
        padding: 0,
        display: 'flex',
        fontSize: 18
      },
      action: {
        top: '17px',
        right: '21px',
        position: 'absolute',
        height: '16px',
        padding: 0,
        marginLeft: '11px',
        '& .MuiButtonBase-root': {
          disableRipple: true,
          '&:hover': {
            backgroundColor: 'transparent'
          }
        },
        color: colors.ultramarine
      },
      message: {
        flex: '1 1 auto',
        padding: 0,
        display: 'flex',
        position: 'relative',
        paddingLeft: '23px',
        paddingRight: '32px',
        flexFlow: 'row wrap',
        color: colors.lynch
      },
      standardSuccess: {
        backgroundColor: colors.white,
        '& .MuiAlert-icon': {
          color: colors.greenIcon
        }
      },
      standardWarning: {
        backgroundColor: colors.white,
        '& .MuiAlert-icon': {
          color: colors.orangeIcon
        }
      },
      standardError: {
        backgroundColor: colors.white,
        '& .MuiAlert-icon': {
          color: colors.redIcon
        }
      }
    }
  };
};

var _default = AlertTheme;
exports["default"] = _default;